import React from 'react';

const WarnIcon = () => {
  return (
    <svg
      width='16'
      height='14'
      viewBox='0 0 16 14'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M7.9974 0.666504L0.664062 13.3332H15.3307L7.9974 0.666504Z'
        stroke='#FF0500'
        strokeWidth='1.33333'
        strokeLinejoin='round'
      />
      <path
        d='M8 10.6663V10.9997M8 5.33301L8.00267 8.66634'
        stroke='#FF0500'
        strokeWidth='1.33333'
        strokeLinecap='round'
      />
    </svg>
  );
};

export default WarnIcon;
